(function () {
  var STORAGE_KEY = 'maroni:recently-viewed';
  var MAX_ITEMS = 12;

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  // Exposed so other components (e.g. product-recommendations-tabs.js) can
  // synchronously check for history without depending on custom-element
  // upgrade/event-dispatch timing, which varies depending on script load
  // order across sections and isn't reliable to coordinate across files.
  window.getRecentlyViewedItems = function (excludeId, limit) {
    return readList()
      .filter(function (item) {
        return item.id !== excludeId;
      })
      .slice(0, limit || 12);
  };

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // localStorage unavailable (private browsing, quota, etc.) - fail silently.
    }
  }

  function trackCurrentProduct() {
    var dataScript = document.querySelector('[data-recently-viewed-product]');
    if (!dataScript) return;

    var product;
    try {
      product = JSON.parse(dataScript.textContent);
    } catch (error) {
      return;
    }
    if (!product || !product.id) return;

    var list = readList().filter(function (item) {
      return item.id !== product.id;
    });
    list.unshift(product);
    writeList(list.slice(0, MAX_ITEMS));
  }

  trackCurrentProduct();

  if (!customElements.get('recently-viewed-products')) {
    customElements.define(
      'recently-viewed-products',
      class RecentlyViewedProducts extends HTMLElement {
        connectedCallback() {
          var currentId = this.dataset.currentProductId ? Number(this.dataset.currentProductId) : null;
          var limit = Number(this.dataset.limit) || 5;
          var items = window.getRecentlyViewedItems(currentId, limit);

          if (items.length === 0) return;

          var list = this.querySelector('[data-recently-viewed-list]');
          if (!list) return;

          list.innerHTML = items.map(this.renderCard).join('');
        }

        renderCard(item) {
          var image = item.image
            ? '<img src="' +
              item.image +
              '" alt="' +
              RecentlyViewedProducts.escape(item.title) +
              '" loading="lazy" width="400" height="400">'
            : '';

          return (
            '<li class="grid__item recently-viewed__item">' +
            '<a href="' +
            RecentlyViewedProducts.escape(item.url) +
            '" class="recently-viewed__card">' +
            '<div class="recently-viewed__media">' +
            image +
            '</div>' +
            '<div class="recently-viewed__content">' +
            '<h3 class="recently-viewed__title">' +
            RecentlyViewedProducts.escape(item.title) +
            '</h3>' +
            '<div class="price">' +
            '<div class="price__regular">' +
            '<span class="price-item price-item--regular">' +
            RecentlyViewedProducts.escape(item.price) +
            '</span>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</a>' +
            '</li>'
          );
        }

        static escape(value) {
          var div = document.createElement('div');
          div.textContent = value == null ? '' : String(value);
          return div.innerHTML;
        }
      }
    );
  }
})();
